module.exports = __webpack_public_path__ + "static/img/parking_equipment1_7.8bf6f7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/parking_equipment1_7.jpg
// module id = Huvl
// module chunks = 0